import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';

const FilterButtons = ({ categories, activeFilter, handleFilterClick, activeCategory, onCategoryChange }) => {
  const active = activeCategory ?? activeFilter;
  const onClick = onCategoryChange ?? handleFilterClick;

  return (
    <FilterContainer>
      {categories.map((category, index) => (
        <FilterButton
          key={index}
          active={active === category}
          onClick={() => onClick && onClick(category)}
          whileHover={{ y: -3 }}
          whileTap={{ y: 0 }}
          transition={{ duration: 0.2 }}
        >
          {category}
        </FilterButton>
      ))}
    </FilterContainer>
  );
};

const FilterContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.8rem;
  margin-bottom: 2rem;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
`;

const FilterButton = styled(motion.button)`
  background-color: ${props => props.active ? 'var(--primary-color)' : 'var(--bg-tertiary)'};
  color: ${props => props.active ? 'white' : 'var(--text-color)'};
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 30px;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.active ? 'var(--primary-dark)' : 'var(--bg-secondary)'};
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  }
`;

export default FilterButtons;